var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGagarin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 36,
    viewBox: "0 0 110 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.451 2.42296C107.732 2.35358 107.968 2.64234 107.839 2.8985C107.47 3.6286 107.514 4.49662 107.954 5.18958C108.107 5.43202 107.903 5.74007 107.616 5.69814C106.796 5.57822 105.97 5.88787 105.439 6.51292C105.253 6.73138 104.892 6.63511 104.843 6.35341C104.706 5.54793 104.153 4.87005 103.385 4.56452C103.116 4.45766 103.098 4.08879 103.355 3.95692C104.088 3.57962 104.572 2.85058 104.63 2.03575C104.65 1.75083 104.999 1.61978 105.206 1.82003C105.798 2.39239 106.648 2.62069 107.451 2.42296Z",
    fill: "#79E0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1367 25.3101V25.3095C11.9833 25.3006 9.42969 22.7785 9.42969 19.6687C9.42969 16.6351 11.8596 14.1608 14.906 14.033L14.907 14.0285C17.2489 13.9635 18.8698 14.2038 19.4688 14.3331V16.2967C18.7262 16.1245 16.5007 15.8959 14.9429 15.9796L14.9429 15.9814C12.9728 16.0801 11.4062 17.6856 11.4062 19.6517C11.4062 21.6814 13.0759 23.3268 15.1355 23.3268C15.1523 23.3268 15.1691 23.3267 15.1859 23.3265L15.186 23.3277C16.5037 23.3258 17.3782 23.2502 17.9493 23.1631V20.5413L19.9297 19.9816L19.9297 24.6612L19.9322 24.6657C19.9322 24.6657 18.7032 25.3101 15.1367 25.3101Z",
    fill: "#EEF9FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6016 25.3101V25.3095C40.4481 25.3006 37.8945 22.7785 37.8945 19.6687C37.8945 16.6351 40.3245 14.1608 43.3708 14.033L43.3718 14.0285C45.7188 13.9633 47.3417 14.2048 47.9375 14.3339V16.2976C47.1989 16.1254 44.9683 15.8958 43.4077 15.9796L43.4078 15.9814C41.4377 16.0801 39.8711 17.6856 39.8711 19.6517C39.8711 21.6814 41.5407 23.3268 43.6003 23.3268C43.6172 23.3268 43.634 23.3267 43.6508 23.3265L43.6508 23.3277C44.9685 23.3258 45.843 23.2502 46.4141 23.1631V20.5435L48.3945 19.9839L48.3945 24.6612L48.397 24.6657C48.397 24.6657 47.1681 25.3101 43.6016 25.3101Z",
    fill: "#EEF9FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3361 14.0117H57.0527L62.1148 25.2598H63.4021V24.6718H64.1336L59.3361 14.0117Z",
    fill: "#EEF9FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0687 21.4893L70.1152 24.5392L70.7509 25.9458L72.8486 25.2913L71.0687 21.4893Z",
    fill: "#EEF9FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6074 14.0141H28.324L23.262 25.2622H25.5454L30.6074 14.0141Z",
    fill: "#EEF9FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3184 14.0141H57.035L51.9729 25.2622H54.2563L59.3184 14.0141Z",
    fill: "#EEF9FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4551 14.0141H30.7385L35.8005 25.2622H33.5171L28.4551 14.0141Z",
    fill: "#EEF9FC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2227 14.0141H82.2099V25.2622H80.2227V14.0141Z",
    fill: "#EEF9FC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3438 14.5202L89.1348 14.0141H89.3304V14.0141H89.7436L95.9297 22.5919V14.0141H97.9163V24.5868L95.5264 25.2622H95.4577L89.3304 16.766V25.2622H87.3438V14.5202Z",
    fill: "#EEF9FC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3516 14.0132L71.9986 14.0132L71.9988 14.0155C72.0204 14.0151 72.042 14.0149 72.0637 14.0149C74.0341 14.0149 75.6313 15.589 75.6313 17.5308C75.6313 19.2211 74.4209 20.6329 72.8075 20.9701L71.074 21.4668L72.793 25.2524H70.4004L68.1597 20.2824L69.6703 19.8528L69.671 19.8505L72.4175 19.0778L72.4172 19.0752C73.1361 18.9154 73.673 18.282 73.673 17.5249C73.673 16.6693 72.987 15.9715 72.1277 15.9371L72.1284 15.9486H67.4105C66.6922 15.9486 66.0401 15.5286 65.7429 14.8746L65.3516 14.0132Z",
    fill: "#EEF9FC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.511 4.5916C81.3951 18.6801 47.9676 32.5909 18.6125 34.3233C13.644 34.6165 9.77586 34.2504 6.9799 33.3844C4.18194 32.5178 2.50986 31.0994 1.82598 29.4519C1.49693 28.6592 1.51476 27.6429 1.82598 26.6362C2.70414 23.796 4.54067 22.627 6.9091 21.1195L6.9799 21.0744C3.97764 22.1868 1.12477 24.5403 0.25675 27.0972C-0.138493 28.2615 -0.0555415 29.5746 0.356001 30.566C1.14718 32.4719 3.34283 34.0464 6.49189 34.9876C9.64506 35.93 12.8955 36.1978 18.6125 35.8604C32.5803 35.0361 49.4064 30.8192 62.3765 25.7364C63.9384 25.1243 65.5105 24.517 67.1013 23.9024C77.958 19.7083 89.6932 15.1748 105.09 6.46281L105.061 6.26487C104.95 5.49912 104.407 4.8661 103.667 4.63949L103.511 4.5916Z",
    fill: "url(#paint0_linear_476_7688)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_476_7688",
    x1: 99.0585,
    y1: 45.2633,
    x2: -0.0686104,
    y2: 13.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471311,
    stopColor: "#0096FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853052,
    stopColor: "#3A5FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A32F0",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGagarin);
export default __webpack_public_path__ + "static/media/Gagarin.f4c292c8a76703bc12d62e5985f18135.svg";
export { ForwardRef as ReactComponent };